<template>
  <div
    class="p-8 w-full flex-no-grow"
    :class="{ 'load load--fill': isLoading }"
  >
    <h1 v-text="'Map Import Columns'" />
    <p v-text="'Choose which columns are represented in the upload data:'" />
    <div class="table-responsive">
      <table class="table table-files min-w-table">
        <thead>
          <tr>
            <th
              v-if="headerRow.length"
              v-text="'Header'"
            />
            <th
              v-for="(row, index) in previewRows"
              :key="`row-${index}`"
            >
              <div class="flex justify-between">
                <span v-text="`Sample row #${index + 1}`" />
                <span
                  v-if="index === previewRows.length - 1"
                  class="mr-4"
                  v-text="`+ ${additionalRowCount} more rows`"
                />
              </div>
            </th>
            <th
              style="padding-left: .5rem !important;"
              v-text="'Map to'"
            />
          </tr>
        </thead>
        <tr
          v-for="(value, key) in fieldMapping"
          :key="key"
        >
          <th v-if="headerRow.length">
            {{ key | snakeToTitle }}
          </th>
          <td
            v-for="(row, index) in previewRows"
            :key="`preview-row-${index}`"
            class="p-2 text-sm"
          >
            <div class="flex items-center">
              <em>{{ row[key] ? row[key] : '-' }}</em>
            </div>
          </td>
          <td
            style="padding-left: .5rem !important;"
            class="px-2 bg-grey-lighter"
          >
            <div class="select-container w-full">
              <select
                :id="key"
                v-model="fieldMapping[key]"
                :name="key"
                class="w-full my-2"
              >
                <option
                  :value="null"
                  v-text="'Do not import this column'"
                />
                <option
                  v-for="availableColumn in availableColumns"
                  :key="availableColumn.id"
                  :value="availableColumn.id"
                  :selected="key === availableColumn.attributes.title"
                >
                  {{ availableColumn.attributes.title | snakeToTitle }}
                </option>
              </select>
            </div>
          </td>
        </tr>
      </table>
    </div>
    <button
      type="button"
      class="btn"
      @click="save"
      v-text="'Next'"
    />
  </div>
</template>

<script type="text/babel">
export default {
  name: 'MapColumns',
  props: {
    memberCSVUploadUuid: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
      selectedRole: 'union-member',
      fieldMapping: {},
      memberCSVUpload: {
        attributes: {
          file_contents: [],
        },
        availableColumns: {
          data: [],
        },
        availableRoles: {
          data: [],
        },
      },
    }
  },
  computed: {
    availableRoles() {
      return _.filter(this.memberCSVUpload.availableRoles.data, function (role) {
        return role.attributes.name !== 'base-permissions'
      })
    },
    availableColumns() {
      return this.memberCSVUpload.availableColumns.data
    },
    previewRows() {
      return this.memberCSVUpload.attributes.file_contents.slice(0, 2)
    },
    headerRow() {
      if (!this.memberCSVUpload.attributes.has_headers) {
        return []
      }

      return Object.keys(this.memberCSVUpload.attributes.file_contents[0])
    },
    additionalRowCount() {
      const totalCount = this.memberCSVUpload.attributes.file_contents.length

      return totalCount > 2
        ? totalCount - 2
        : 0
    },
  },
  async mounted() {
    await this.$nextTick()

    this.fetch()
  },
  methods: {
    fetch() {
      this.isLoading = true

      this.$api.active().get(`memberships/imports/${this.memberCSVUploadUuid}?include=availableRoles,availableColumns`)
        .then((response) => {
          this.isLoading = false
          this.memberCSVUpload = response.data

          this.setFieldMapping()
        }).catch(() => {
          this.isLoading = false

          this.$store.commit('baseAddNotification', {
            title: 'Error!',
            text: 'There was a problem retrieving the data.',
            type: 'error',
          })
        })
    },
    save() {
      this.isLoading = true

      this.$api.active().post(`memberships/imports/${this.memberCSVUploadUuid}/map-columns`, {
        column_mapping: this.fieldMapping,
      }).then(() => {
        window.location.replace(this.$urlGenerator.active('members/imports/history?status=Import is processing!'))
      }).catch(() => {
        this.isLoading = false

        this.$store.commit('baseAddNotification', {
          title: 'Error!',
          text: 'There was a problem mapping the fields',
          type: 'error',
        })
      })
    },
    setFieldMapping() {
      const vm = this

      _.forEach(Object.keys(this.previewRows[0]), function (column) {
        const availableColumn = _.find(vm.availableColumns, { 'id': column })
        const columnValue = availableColumn
          ? availableColumn.id
          : null

        vm.$set(vm.fieldMapping, column, columnValue)
      })
    },
  },
}
</script>
